define('LoyaltyPrice.PDP.View', [
    'Backbone',
    'Utils',
    '_loyalty_pdp_view.tpl',
    'SC.Configuration',
    'Profile.Model',
    'LoyaltyPrice.Helper'
], function LoyaltyPricePDPView(
    Backbone,
    Utils,
    ViewTpl,
    Configuration,
    ProfileModel,
    LoyaltyPriceHelper
) {
    'use strict';

    return Backbone.View.extend({

        template: ViewTpl,

        initialize: function initialize(options) {
            this.item = options.item.item;
            this.profile = ProfileModel.getInstance();
        },

        showDiscount: function showDiscount() {
            var isLoggedIn = this.profile.get('isLoggedIn') === 'T';
            var loyaltyPrice = this.item.custitem_aws_loyaltyprice_stored;
            var storePrice = LoyaltyPriceHelper.resolveStorePriceForItem(this.item, this.profile);
            var isLoggedInAndLoyaltyDisabled = !LoyaltyPriceHelper.customerIsLoggedInAnLoyaltyEnabled(this.profile);
            var hasLoyaltyPriceAndIsLess = loyaltyPrice && parseFloat(loyaltyPrice) < parseFloat(storePrice);
            return (!isLoggedIn && hasLoyaltyPriceAndIsLess) || (isLoggedInAndLoyaltyDisabled && hasLoyaltyPriceAndIsLess);
        },

        getContext: function getContext() {
            return {
                show: this.showDiscount(),
                itemName: this.item.keyMapping_name,
                loyaltyPrice: Utils.formatCurrency(this.item.custitem_aws_loyaltyprice_stored),
                msg: Configuration.get('LoyaltyPrice.configMessage')
            };
        }
    });
});
